import * as React from 'react';

/**
 * Shared arrowhead marker reused by custom edges.
 *
 * Why an <svg> with width/height 0? We only need the marker definition present in the DOM – it is not directly rendered.
 *
 * https://reactflow.dev/examples/edges/markers
 *
 * Example usage (inside a ReactFlow instance):
 * <ReactFlow edgeTypes={{ custom: CustomEdge }} ...props>
 *   <EdgeMarker />
 *   ...other children...
 * </ReactFlow>
 *
 *
 * where the custom edge would reference this marker via:
 * markerEnd="url(#custom-edge-arrow)"
 *
 * This allows the edge to use the defined arrowhead marker for its end point.
 */
export const EdgeMarker = () => (
  <svg width={0} height={0}>
    {/* <defs> stores reusable SVG definitions that are *not* rendered until referenced. */}
    <defs>
      {/*
        <marker> defines a reusable arrowhead shape.
        Referenced by edges via: markerEnd="url(#custom-edge-arrow)".
      */}
      <marker
        id="custom-edge-arrow"
        markerWidth={20}
        markerHeight={15}
        viewBox="-10 -10 20 20"
        markerUnits="strokeWidth"
        orient="auto-start-reverse"
        refX={0}
        refY={0}
      >
        <polyline
          points="-5,-4 0,0 -5,4"
          stroke="context-stroke"
          fill="none"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </marker>
    </defs>
  </svg>
);
